module.exports = __webpack_public_path__ + "img/ukpl-logo-new.11c5b615.png";